module.exports = __webpack_public_path__ + "static/media/planslist.8b3036b4.PNG";